/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportColumnsData } from '../models/ReportColumnsData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportsService {
  /**
   * Get Report Columns
   * @param language Language of the column labels, default is 'en'
   * @returns ReportColumnsData Successful Response
   * @throws ApiError
   */
  public static getReportColumns(language?: string | null): CancelablePromise<ReportColumnsData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/columns',
      query: {
        language: language,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Paid Transaction Reports
   * @param language Language of the report, default is 'en'
   * @param createdDateFrom Filter orders created from this date
   * @param createdDateTo Filter orders created up to this date
   * @param orderPageIds Only include rows of these order pages / pass pages
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getOrdersReport(
    language?: string | null,
    createdDateFrom?: string | null,
    createdDateTo?: string | null,
    orderPageIds?: Array<string> | null,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/orders',
      query: {
        language: language,
        created_date_from: createdDateFrom,
        created_date_to: createdDateTo,
        order_page_ids: orderPageIds,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Workshop Reports
   * @param language Language of the report, default is 'en'
   * @param createdDateFrom Filter orders created from this date
   * @param createdDateTo Filter orders created up to this date
   * @param orderPageIds Only include rows of these order pages / pass pages
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getWorkshopsReport(
    language?: string | null,
    createdDateFrom?: string | null,
    createdDateTo?: string | null,
    orderPageIds?: Array<string> | null,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/reports/workshops',
      query: {
        language: language,
        created_date_from: createdDateFrom,
        created_date_to: createdDateTo,
        order_page_ids: orderPageIds,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
